<div mat-dialog-title class="matDialogTitle" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <div class="div_loading">
        <div class="my-container" [hidden]="!loading">
            <mat-progress-bar mode="indeterminate" class="detaile"></mat-progress-bar>
        </div>
    </div>
    <span>لیست طرف حساب ها</span>
    <span class="close" (click)="close()">
        <mat-icon>close</mat-icon>
    </span>
</div>

<div mat-dialog-content class="matDialogContent" style="overflow-y:hidden">
    <input class="pe1" style="width:100%" (keyup)="get_user(2)" name="title_search" [(ngModel)]="title_search"
        autocomplete="off" placeholder="{{ messageService.get_search() }}">

    <div class="content-body control-content-body" style='overflow-x:auto;direction:rtl;max-height: 25rem;'>
        <mat-table [dataSource]="dataSource" class='table-scroll pe1'>

            <ng-container matColumnDef="row">
                <mat-header-cell *matHeaderCellDef style="max-width:40px">
                    #
                </mat-header-cell>
                <mat-cell *matCellDef="let x;let i = index" style="max-width:40px" [ngClass]="{'en':dir == 'ltr'}">{{
                    i+1 }}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="user">
                <mat-header-cell *matHeaderCellDef>
                    <span>نام مشتری</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x" (click)="select(x.user_id,x.user_title)" class="cursor"
                    style="text-align: center;">
                    <div class="right" [ngClass]="{'en':dir == 'ltr','left':dir == 'ltr'}">{{ x.user_title | substr:0:20
                        }}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="cellphone">
                <mat-header-cell *matHeaderCellDef>
                    <span>شماره همراه</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x" (click)="select(x.user_id,x.user_title)" class="cursor"
                    style="text-align: center;">
                    <div *ngIf="show_cellphone == true" [ngClass]="{'en':dir == 'ltr'}">{{ x.user_cellPhone }}</div>
                    <div *ngIf="show_cellphone == false" class="cellphone" [ngClass]="{'en':dir == 'ltr'}">{{
                        x.user_cellPhone | hide_cellphone
                        }}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="phone">
                <mat-header-cell *matHeaderCellDef>
                    <span>شماره ثابت</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let x" (click)="select(x.user_id,x.user_title)" class="cursor"
                    style="text-align: center;">
                    <div *ngIf="show_cellphone == true" [ngClass]="{'en':dir == 'ltr'}">{{ x.user_phone }}</div>
                    <div *ngIf="show_cellphone == false" class="cellphone" [ngClass]="{'en':dir == 'ltr'}">{{
                        x.user_phone | hide_cellphone
                        }}</div>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns" color="primary"></mat-header-row>
            <mat-row *matRowDef="let x;let i = index;columns:displayedColumns"></mat-row>
        </mat-table>
    </div>
</div>